"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _useInterval = _interopRequireDefault(require("../../../hooks/useInterval"));

var _theming = require("../../../theming");

var _Loading = _interopRequireDefault(require("../../DataViz/Loading/Loading"));

var _themeContants = require("../../../constants/themeContants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var FullScreenLoader = function FullScreenLoader(_ref) {
  var messages = _ref.messages,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 50000 : _ref$delay,
      _ref$animation = _ref.animation,
      animation = _ref$animation === void 0 ? 1000 : _ref$animation,
      variant = _ref.variant;

  // state variables
  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      count = _useState2[0],
      setCount = _useState2[1];

  var _useState3 = (0, _react.useState)(messages[0]),
      _useState4 = _slicedToArray(_useState3, 2),
      currentMsg = _useState4[0],
      setCurrentMsg = _useState4[1];

  var _useState5 = (0, _react.useState)(""),
      _useState6 = _slicedToArray(_useState5, 2),
      previousMsg = _useState6[0],
      setPreviousMsg = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      hasLooped = _useState8[0],
      setHasLooped = _useState8[1]; // variables


  var maxCount = messages.length - 1;

  var handleLooped = function handleLooped() {
    setCount(0);
    setHasLooped(true);
  }; // hooks


  (0, _useInterval["default"])(function () {
    maxCount > count ? setCount(count + 1) : handleLooped();
  }, delay);
  (0, _react.useEffect)(function () {
    setCurrentMsg(messages[count]);

    if (count === 0 && hasLooped) {
      setPreviousMsg(messages[maxCount]);
    } else if (count > 0) {
      setPreviousMsg(messages[count - 1]);
    }
  }, [count, hasLooped]);
  return _react["default"].createElement(FullScreenContainer, {
    variant: variant
  }, _react["default"].createElement(InnerContainer, {
    variant: variant
  }, _react["default"].createElement(_Loading["default"], null), _react["default"].createElement(MessagesContainer, {
    variant: variant
  }, previousMsg && _react["default"].createElement(PreviousMsg, {
    key: previousMsg,
    animation: animation,
    variant: variant
  }, previousMsg), currentMsg && _react["default"].createElement(CurrentMsg, {
    key: currentMsg,
    animation: animation,
    variant: variant
  }, currentMsg))));
};

FullScreenLoader.themeProps = {
  mainContainer: {
    name: "FULLSCREENLOADER_MAINCONTAINER",
    description: "",
    type: _themeContants.themePropTypes.style
  },
  innerContainer: {
    name: "FULLSCREENLOADER_INNERCONTAINER",
    description: "",
    type: _themeContants.themePropTypes.style
  },
  messagesContainer: {
    name: "FULLSCREENLOADER_MESSAGESCONTAINER",
    description: "",
    type: _themeContants.themePropTypes.style
  },
  message: {
    name: "FULLSCREENLOADER_MESSAGESSTYLE",
    description: "",
    type: _themeContants.themePropTypes.style
  },
  previousMessage: {
    name: "FULLSCREENLOADER_PREVIOUSMESSAGE",
    description: "",
    type: _themeContants.themePropTypes.style
  },
  currentMessage: {
    name: "FULLSCREENLOADER_CURRENTMESSAGE",
    description: "",
    type: _themeContants.themePropTypes.style
  }
};

var FullScreenContainer = _styledComponents["default"].div.withConfig({
  displayName: "FullScreenLoader__FullScreenContainer",
  componentId: "sc-1c7v14y-0"
})(["position:fixed;left:0;top:0;width:100vw;height:100vh;z-index:999;background-color:", ";display:flex;justify-content:center;align-items:center;", ";"], _theming.color.black, (0, _theming.applyVariants)(FullScreenLoader.themeProps.mainContainer));

var InnerContainer = _styledComponents["default"].div.withConfig({
  displayName: "FullScreenLoader__InnerContainer",
  componentId: "sc-1c7v14y-1"
})(["display:flex;flex-direction:column;align-items:center;width:100%;", ";"], (0, _theming.applyVariants)(FullScreenLoader.themeProps.innerContainer));

var MessagesContainer = _styledComponents["default"].div.withConfig({
  displayName: "FullScreenLoader__MessagesContainer",
  componentId: "sc-1c7v14y-2"
})(["margin-top:", ";position:relative;width:100%;", ";"], _theming.spacing.large, (0, _theming.applyVariants)(FullScreenLoader.themeProps.messagesContainer));

var messageStyle = (0, _styledComponents.css)(["color:", ";font-size:", ";text-align:center;position:absolute;top:0;left:0;right:0;padding:0 ", ";@media (max-width:425px){font-size:", ";}", ";"], _theming.color.white, _theming.font.h2, _theming.spacing.medium, _theming.font.input, (0, _theming.applyVariants)(FullScreenLoader.themeProps.message));

var PreviousMsg = _styledComponents["default"].div.withConfig({
  displayName: "FullScreenLoader__PreviousMsg",
  componentId: "sc-1c7v14y-3"
})(["", ";animation:fadeout ", "ms linear;animation-fill-mode:forwards;@keyframes fadeout{0%{opacity:1;}100%{opacity:0;}}", ";"], messageStyle, function (p) {
  return p.animation;
}, (0, _theming.applyVariants)(FullScreenLoader.themeProps.previousMessage));

var CurrentMsg = _styledComponents["default"].div.withConfig({
  displayName: "FullScreenLoader__CurrentMsg",
  componentId: "sc-1c7v14y-4"
})(["", ";animation:fadein ", "ms linear;@keyframes fadein{0%{opacity:0;}100%{opacity:1;}}", ";"], messageStyle, function (p) {
  return p.animation;
}, (0, _theming.applyVariants)(FullScreenLoader.themeProps.currentMessage));

FullScreenLoader.propTypes = {
  messages: _propTypes["default"].array.isRequired
};
var _default = FullScreenLoader;
exports["default"] = _default;